<template>
    <MainPage 
        :isSideMenu="false" 
        :isCampaign="true" 
        :isFlashSale="$route.name == 'campaignflashsale'"
        :subPageName="detailController.campaign.name"
    >
        <div>
            <div v-if="isAccountLoaded">
                <div v-if="isLoaded">
                    <DefaultLayout
                        :lbl="lbl"
                        :localeCode="localeCode"
                        :isLogin="isLogin"
                        :userPoint="point"
                        :detailController="detailController"
                        :modalController="modalController"
                        :redeemController="redeemController" />
                </div>
                <ModalMaster :controller="modalController" />
            </div>
        </div>
    </MainPage>
</template>
<script>
//config
import Config from '@/config/ConfigManager.js';
//core
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
//helper
import Account from "@/helper/AccountHelper.js";
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import DefaultLayout from "../component/layout/Default.vue";
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';

export default {
    name: "Campaign",
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin, ModalMixin],
    components: {
        MainPage,
        DefaultLayout
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),
            point: null,
        };
    },
    created: function() {

        this.initialIsFromLanding();
        this.initialRedeemModal(); //ModalMixin
        this.initialAddToCardModal();
    },
    mounted: function() {
        this.modalController.loadingModal.show();
    },
    methods: {
        //mixin initial
        accountInitiated: function () {
            this.initialCampaign();
        },
        langSwitched: function () {
            this.getAccountData(); //AccountMixin
            this.initialCampaign();
        },
        //event
        logout: function () {
            Account.setLogout().finally(() => {
                this.$router.push('/home');
            });
        },
        //initial
        initialCampaign: function () {
            var campaignId = this.$route.params.campaignId;
            this.blobConfig = Account.getCacheBlob()
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .setWithRelate(true)
                .setRelateConfig(this.blobConfig.relate_campaign_list_config)
                .setRelateTop(this.blobConfig.show_top_relate_campaign)
                .create();

            this.detailController.initial(this.campaignConfig, this.modalController);

            this.initialDetailControllerCallback();
        },
        initialIsFromLanding: function () {
            var cacheHelper = new CacheHelper(Config.getCacheType());
            if (cacheHelper.getCache('isfromlanding') != undefined) {
                var landingCache = JSON.parse(cacheHelper.getCache('isfromlanding'));
                cacheHelper.removeCache('isfromlanding');

                if (landingCache == 'wodd') return;
                var backAmount = (landingCache == 'interface') ? -3 : -2;
                history.go(backAmount);
            }
        },
        //detail controller callback
        initialDetailControllerCallback: function () {
            this.detailController.onApiSuccess(data => {
                switch (data.tag) {
                    case 'get-campaign':
                        this.redeemController.initial(this.detailController.campaign, this.modalController);
                        this.isLoaded = true;
                        break;
                    default:
                        this.isLoaded = true;
                        break;
                }
            });

            this.detailController.onApiError(data => {
                switch (data.tag) {
                    case 'get-campaign':
                        this.errorResponse(data.err, this.errorHandler);
                        break;
                    default:
                        this.errorResponse(data.err, this.errorHandler);
                        break;
                }
            });
        },
        //redeem controller callback
        initialRedeemControllerCallback: function () {
            this.redeemController.onRedeemSuccess(data => {
                switch (data.tag) {
                    case 'redeem':
                        break;
                    case 'add-cart':
                        break;
                    default:
                        break;
                }
            });

            this.redeemController.onErrorApi(data => {
                switch (data.tag) {
                    case 'redeem':
                        this.errorResponse(data.err, this.errorHandler);
                        break;
                    case 'add-cart':
                        this.errorResponse(data.err, this.errorHandler);
                        break;
                    default:
                        this.errorResponse(data.err, this.errorHandler);
                        break;
                }
            });
        }
    }
}
</script>

